function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["react-async-table"] = t(require("react")) : e["react-async-table"] = t(e.react);
}(this, function (e) {
  return function (e) {
    var t = {};
    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) n.d(o, r, function (t) {
        return e[t];
      }.bind(null, r));
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 9);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(2)();
  }, function (e, t, n) {
    "use strict";

    var o = n(3);
    function r() {}
    function a() {}
    a.resetWarningCache = r, e.exports = function () {
      function e(e, t, n, r, a, i) {
        if (i !== o) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: r
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    var o = n(5);
    "string" == typeof o && (o = [[e.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(7)(o, r);
    o.locals && (e.exports = o.locals);
  }, function (e, t, n) {
    (t = n(6)(!1)).push([e.i, ".async-table-search-clear{margin-left:-40px;z-index:100}.async-table-header-actions button{margin:0px 0px 0px 5px}.async-table-header-actions .badge{padding-top:5px !important}.async-table-style thead tr th{vertical-align:middle}.async-table-style thead tr th .header-checkbox{margin:-6px 0px 0px 0px}.async-table-style thead tr th button.btn-link{margin:0px 5px 0px 5px;padding:0;text-decoration:none}.async-table-style thead tr th button.sort-button{float:right !important}.async-table-style tbody tr td button.btn-link{margin:0px;padding:0px;text-decoration:none}.async-table-style tbody tr td{vertical-align:middle}.async-table-style tbody tr td .body-checkbox{margin:-6px 0px 0px 0px}.async-table-style tbody tr td.action-col{text-align:center;position:relative;min-width:100px}.async-table-style tbody tr td.action-col span button{padding:0px 5px 0px 5px}\n", ""]), e.exports = t;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
              o = e[3];
            if (!o) return n;
            if (t && "function" == typeof btoa) {
              var r = (i = o, c = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(c), "/*# ".concat(l, " */")),
                a = o.sources.map(function (e) {
                  return "/*# sourceURL=".concat(o.sourceRoot || "").concat(e, " */");
                });
              return [n].concat(a).concat([r]).join("\n");
            }
            var i, c, l;
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n, o) {
        "string" == typeof e && (e = [[null, e, ""]]);
        var r = {};
        if (o) for (var a = 0; a < this.length; a++) {
          var i = this[a][0];
          null != i && (r[i] = !0);
        }
        for (var c = 0; c < e.length; c++) {
          var l = [].concat(e[c]);
          o && r[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), t.push(l));
        }
      }, t;
    };
  }, function (e, t, n) {
    var o,
      r,
      a = {},
      i = (o = function o() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === r && (r = o.apply(this, arguments)), r;
      }),
      c = function c(e, t) {
        return t ? t.querySelector(e) : document.querySelector(e);
      },
      l = function (e) {
        var t = {};
        return function (e, n) {
          if ("function" == typeof e) return e();
          if (void 0 === t[e]) {
            var o = c.call(this, e, n);
            if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
              o = o.contentDocument.head;
            } catch (e) {
              o = null;
            }
            t[e] = o;
          }
          return t[e];
        };
      }(),
      s = null,
      u = 0,
      p = [],
      f = n(8);
    function d(e, t) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n],
          r = a[o.id];
        if (r) {
          r.refs++;
          for (var i = 0; i < r.parts.length; i++) r.parts[i](o.parts[i]);
          for (; i < o.parts.length; i++) r.parts.push(v(o.parts[i], t));
        } else {
          var c = [];
          for (i = 0; i < o.parts.length; i++) c.push(v(o.parts[i], t));
          a[o.id] = {
            id: o.id,
            refs: 1,
            parts: c
          };
        }
      }
    }
    function m(e, t) {
      for (var n = [], o = {}, r = 0; r < e.length; r++) {
        var a = e[r],
          i = t.base ? a[0] + t.base : a[0],
          c = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        o[i] ? o[i].parts.push(c) : n.push(o[i] = {
          id: i,
          parts: [c]
        });
      }
      return n;
    }
    function h(e, t) {
      var n = l(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var o = p[p.length - 1];
      if ("top" === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), p.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" != _typeof(e.insertAt) || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var r = l(e.insertAt.before, n);
        n.insertBefore(t, r);
      }
    }
    function b(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = p.indexOf(e);
      t >= 0 && p.splice(t, 1);
    }
    function y(e) {
      var t = document.createElement("style");
      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var o = function () {
          0;
          return n.nc;
        }();
        o && (e.attrs.nonce = o);
      }
      return g(t, e.attrs), h(e, t), t;
    }
    function g(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }
    function v(e, t) {
      var n, o, r, a;
      if (t.transform && e.css) {
        if (!(a = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
        e.css = a;
      }
      if (t.singleton) {
        var i = u++;
        n = s || (s = y(t)), o = C.bind(null, n, i, !1), r = C.bind(null, n, i, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", g(t, e.attrs), h(e, t), t;
      }(t), o = w.bind(null, n, t), r = function r() {
        b(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = y(t), o = S.bind(null, n), r = function r() {
        b(n);
      });
      return o(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          o(e = t);
        } else r();
      };
    }
    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" == _typeof(t.attrs) ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = m(e, t);
      return d(n, t), function (e) {
        for (var o = [], r = 0; r < n.length; r++) {
          var i = n[r];
          (c = a[i.id]).refs--, o.push(c);
        }
        e && d(m(e, t), t);
        for (r = 0; r < o.length; r++) {
          var c;
          if (0 === (c = o[r]).refs) {
            for (var l = 0; l < c.parts.length; l++) c.parts[l]();
            delete a[c.id];
          }
        }
      };
    };
    var E,
      x = (E = [], function (e, t) {
        return E[e] = t, E.filter(Boolean).join("\n");
      });
    function C(e, t, n, o) {
      var r = n ? "" : o.css;
      if (e.styleSheet) e.styleSheet.cssText = x(t, r);else {
        var a = document.createTextNode(r),
          i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
      }
    }
    function S(e, t) {
      var n = t.css,
        o = t.media;
      if (o && e.setAttribute("media", o), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) e.removeChild(e.firstChild);
        e.appendChild(document.createTextNode(n));
      }
    }
    function w(e, t, n) {
      var o = n.css,
        r = n.sourceMap,
        a = void 0 === t.convertToAbsoluteUrls && r;
      (t.convertToAbsoluteUrls || a) && (o = f(o)), r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
      var i = new Blob([o], {
          type: "text/css"
        }),
        c = e.href;
      e.href = URL.createObjectURL(i), c && URL.revokeObjectURL(c);
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var n = t.protocol + "//" + t.host,
        o = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var r,
          a = t.trim().replace(/^"(.*)"$/, function (e, t) {
            return t;
          }).replace(/^'(.*)'$/, function (e, t) {
            return t;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (r = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? n + a : o + a.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")");
      });
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(0),
      r = n.n(o),
      a = n(1),
      i = n.n(a),
      c = function c(e) {
        var t = e.active,
          n = e.disabled,
          o = e.children,
          a = t ? "active" : "",
          i = n ? "disabled" : "";
        return r.a.createElement("li", {
          className: "page-item ".concat(a, " ").concat(i)
        }, o);
      };
    c.propTypes = {
      active: i.a.bool,
      disabled: i.a.bool,
      children: i.a.node.isRequired
    }, c.defaultProps = {
      active: !1,
      disabled: !1
    };
    var l = function l(e) {
      var t = e.page,
        n = e.previous,
        o = e.next,
        a = e.onClick,
        i = e.children,
        c = function c() {
          return a(t);
        };
      if (n || o) {
        var l = n ? "Previous" : "Next",
          s = n ? "‹" : "›";
        return r.a.createElement("button", {
          className: "page-link",
          "aria-label": l,
          onClick: c
        }, r.a.createElement("span", {
          "aria-hidden": "true"
        }, s), r.a.createElement("span", {
          className: "sr-only"
        }, l));
      }
      return r.a.createElement("button", {
        className: "page-link",
        onClick: c
      }, i);
    };
    function s(e) {
      return (s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }
    function u(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }
    function p(e, t) {
      return !t || "object" !== s(t) && "function" != typeof t ? f(e) : t;
    }
    function f(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function d() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }
    function m(e) {
      return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function h(e, t) {
      return (h = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    l.propTypes = {
      page: i.a.number.isRequired,
      previous: i.a.bool,
      next: i.a.bool,
      onClick: i.a.func.isRequired,
      children: i.a.node
    }, l.defaultProps = {
      previous: !1,
      next: !1
    };
    var b = {
        items: i.a.number.isRequired,
        onChangePage: i.a.func.isRequired,
        currentPage: i.a.number,
        pageSize: i.a.number,
        firstLink: i.a.string,
        lastLink: i.a.string
      },
      y = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && h(e, t);
        }(s, e);
        var t,
          n,
          o,
          a,
          i = (t = s, function () {
            var e,
              n = m(t);
            if (d()) {
              var o = m(this).constructor;
              e = Reflect.construct(n, arguments, o);
            } else e = n.apply(this, arguments);
            return p(this, e);
          });
        function s(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, s), (t = i.call(this, e)).state = {
            pager: {}
          }, t.setPage = t.setPage.bind(f(t)), t;
        }
        return n = s, (o = [{
          key: "componentDidMount",
          value: function value() {
            this.props.items && this.setPage(this.props.currentPage, !1);
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            this.props.currentPage !== e.currentPage && this.setPage(this.props.currentPage, !1), this.props.items !== e.items && this.setPage(this.props.currentPage, !1);
          }
        }, {
          key: "range",
          value: function value(e, t) {
            return Array.from({
              length: t - e
            }, function (t, n) {
              return n + e;
            });
          }
        }, {
          key: "setPage",
          value: function value(e) {
            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
              n = this.props.items || 1,
              o = this.state.pager;
            if (!(e < 1 || e > o.totalPages)) {
              var r = this.props.pageSize || 10;
              o = this.getPager(n, e, r);
              var a = e;
              this.setState({
                pager: o
              }), t && this.props.onChangePage(a);
            }
          }
        }, {
          key: "getPager",
          value: function value(e, t, n) {
            t = t || 1;
            var o,
              r,
              a = Math.ceil(e / n);
            a <= 10 ? (o = 1, r = a) : t <= 6 ? (o = 1, r = 10) : t + 4 >= a ? (o = a - 9, r = a) : (o = t - 5, r = t + 4);
            var i = (t - 1) * n;
            return {
              totalItems: e,
              currentPage: t,
              pageSize: n,
              totalPages: a,
              startPage: o,
              endPage: r,
              startIndex: i,
              endIndex: Math.min(i + n - 1, e - 1),
              pages: this.range(o, r + 1)
            };
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.state.pager;
            return !t.pages || t.pages.length <= 1 ? null : r.a.createElement("nav", {
              "aria-label": "pagination"
            }, r.a.createElement("ul", {
              className: "pagination"
            }, r.a.createElement(c, {
              disabled: 1 === t.currentPage
            }, r.a.createElement(l, {
              page: 1,
              onClick: this.setPage
            }, this.props.firstLink)), r.a.createElement(c, {
              disabled: 1 === t.currentPage
            }, r.a.createElement(l, {
              page: t.currentPage - 1,
              onClick: this.setPage,
              previous: !0
            })), t.pages.map(function (n, o) {
              return r.a.createElement(c, {
                key: o,
                active: t.currentPage === n
              }, r.a.createElement(l, {
                page: n,
                onClick: e.setPage
              }, n));
            }), r.a.createElement(c, {
              disabled: t.currentPage === t.totalPages
            }, r.a.createElement(l, {
              page: t.currentPage + 1,
              onClick: this.setPage,
              next: !0
            })), r.a.createElement(c, {
              disabled: t.currentPage === t.totalPages
            }, r.a.createElement(l, {
              page: t.totalPages,
              onClick: this.setPage
            }, this.props.lastLink))));
          }
        }]) && u(n.prototype, o), a && u(n, a), s;
      }(r.a.Component);
    y.propTypes = b, y.defaultProps = {
      currentPage: 1,
      firstLink: "First",
      lastLink: "Last"
    };
    var g = y;
    function v(e) {
      return (v = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }
    function E(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }
    function x(e, t) {
      return !t || "object" !== v(t) && "function" != typeof t ? C(e) : t;
    }
    function C(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function S() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }
    function w(e) {
      return (w = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function k(e, t) {
      return (k = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    var P = {
        placeholder: i.a.string,
        query: i.a.string.isRequired,
        onChange: i.a.func.isRequired
      },
      R = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && k(e, t);
        }(c, e);
        var t,
          n,
          o,
          a,
          i = (t = c, function () {
            var e,
              n = w(t);
            if (S()) {
              var o = w(this).constructor;
              e = Reflect.construct(n, arguments, o);
            } else e = n.apply(this, arguments);
            return x(this, e);
          });
        function c(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (t = i.call(this, e)).state = {
            searchTerm: ""
          }, t.onChange = t.onChange.bind(C(t)), t.onClear = t.onClear.bind(C(t)), t;
        }
        return n = c, (o = [{
          key: "componentDidMount",
          value: function value() {
            var e = this.props.query;
            this.setState({
              searchTerm: e
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            e.query !== this.props.query && !this.props.query && this.state.searchTerm && this.setState({
              searchTerm: ""
            });
          }
        }, {
          key: "onChange",
          value: function value(e) {
            var t = e.target.value;
            this.setState({
              searchTerm: t
            }), this.props.onChange(t);
          }
        }, {
          key: "onClear",
          value: function value() {
            this.setState({
              searchTerm: ""
            }), this.props.onChange("");
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.state.searchTerm,
              t = this.props.placeholder;
            return r.a.createElement("div", {
              className: "input-group"
            }, r.a.createElement("input", {
              type: "text",
              className: "form-control",
              name: "search",
              value: e,
              placeholder: t,
              onChange: this.onChange
            }), e && r.a.createElement("button", {
              type: "button",
              className: "btn async-table-search-clear",
              onClick: this.onClear
            }, "×"));
          }
        }]) && E(n.prototype, o), a && E(n, a), c;
      }(r.a.Component);
    R.propTypes = P, R.defaultProps = {
      placeholder: "Search..."
    };
    var O = R,
      I = {
        tableHeaderClass: i.a.string,
        selectAllItems: i.a.bool.isRequired,
        columns: i.a.arrayOf(i.a.object.isRequired).isRequired,
        options: i.a.objectOf(i.a.bool).isRequired,
        tooltipIcon: i.a.string,
        sortTitle: i.a.string,
        sortIcon: i.a.string,
        actionsColumnTitle: i.a.string,
        onMultipleSelect: i.a.func.isRequired,
        onSort: i.a.func.isRequired
      },
      T = function T(e) {
        var t = e.tableHeaderClass,
          n = e.selectAllItems,
          o = e.columns,
          a = e.options,
          i = e.tooltipIcon,
          c = e.sortTitle,
          l = e.sortIcon,
          s = e.actionsColumnTitle,
          u = e.onMultipleSelect,
          p = e.onSort;
        return r.a.createElement("thead", {
          className: t
        }, r.a.createElement("tr", null, a.multipleSelect && r.a.createElement("th", null, r.a.createElement("div", {
          className: "form-check"
        }, r.a.createElement("input", {
          className: "form-check-input position-static",
          type: "checkbox",
          name: "selectAllItems",
          onChange: u,
          checked: n
        }))), a.expandable && r.a.createElement("th", null), o.map(function (e, t) {
          return r.a.createElement("th", {
            key: t
          }, e.text, e.tooltip && r.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-html": "true",
            "data-toggle": "tooltip",
            title: e.tooltip
          }, i ? r.a.createElement("i", {
            className: i
          }) : r.a.createElement("i", null, "?")), e.sort && r.a.createElement("button", {
            type: "button",
            className: "btn btn-link sort-button",
            "data-html": "true",
            "data-toggle": "tooltip",
            title: c,
            onClick: function onClick() {
              return p(e.dataField);
            }
          }, l ? r.a.createElement("i", {
            className: l
          }) : r.a.createElement("i", null, "⇕")));
        }), a.actionsColumn && r.a.createElement("th", null, s)));
      };
    T.propTypes = I;
    var j = T,
      A = function A(e, t, n) {
        return e > 1 ? e <= Math.ceil(n / t) ? e : e - 1 : 1;
      },
      q = {
        keyField: i.a.string.isRequired,
        item: i.a.object.isRequired,
        selectedItems: i.a.object.isRequired,
        expandRow: i.a.object.isRequired,
        columns: i.a.arrayOf(i.a.object.isRequired).isRequired,
        totalColumns: i.a.number.isRequired,
        options: i.a.objectOf(i.a.bool).isRequired,
        translations: i.a.objectOf(i.a.string).isRequired,
        icons: i.a.objectOf(i.a.string).isRequired,
        actionsComponent: i.a.func,
        expandableRowComponent: i.a.func.isRequired,
        onSelect: i.a.func.isRequired,
        onExpand: i.a.func.isRequired,
        onEdit: i.a.func.isRequired,
        onDelete: i.a.func.isRequired,
        onAction: i.a.func,
        onColumnClick: i.a.func.isRequired
      },
      N = function N(e) {
        var t = e.keyField,
          n = e.item,
          o = e.selectedItems,
          a = e.expandRow,
          c = e.columns,
          l = e.translations,
          s = e.icons,
          u = e.actionsComponent,
          p = e.expandableRowComponent,
          f = e.totalColumns,
          d = e.options,
          m = n[t],
          h = l.editAction,
          b = l.deleteAction,
          y = s.expandIcon,
          g = s.editActionIcon,
          v = s.deleteActionIcon,
          E = d.expandable,
          x = p,
          C = function C() {
            e.onEdit(m, n);
          },
          S = function S() {
            e.onDelete(m);
          },
          w = function w(t, o) {
            switch (o) {
              case "EDIT_ITEM":
                return void e.onEdit(m, n);
              case "DELETE_ITEM":
                return void e.onDelete(m);
            }
            e.onAction(o, n);
          },
          k = function k(t) {
            var o,
              a = t.column;
            if (!(o = n) || !Object.keys(o).length) return r.a.createElement("td", null);
            var i = a.formatedField,
              c = a.dataField || "";
            return r.a.createElement("td", null, i ? r.a.createElement(i, {
              columnKey: c,
              row: n,
              onColumnClick: e.onColumnClick
            }) : r.a.createElement("span", null, n[c]));
          };
        k.propTypes = {
          column: i.a.object.isRequired
        };
        var P = function P() {
          var e = u;
          return r.a.createElement("td", {
            className: "action-col"
          }, e ? r.a.createElement(e, {
            row: n,
            onAction: w
          }) : r.a.createElement("span", null, r.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            onClick: C,
            "data-html": "true",
            "data-toggle": "tooltip",
            title: h
          }, g ? r.a.createElement("i", {
            className: g
          }) : r.a.createElement("i", null, "✍")), r.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-toggle": "tooltip",
            title: b,
            onClick: S
          }, v ? r.a.createElement("i", {
            className: v
          }) : r.a.createElement("i", null, "−"))));
        };
        return r.a.createElement("tbody", null, r.a.createElement("tr", null, d.multipleSelect && r.a.createElement("td", null, r.a.createElement("div", {
          className: "form-check"
        }, r.a.createElement("input", {
          className: "form-check-input position-static",
          type: "checkbox",
          name: m,
          onChange: e.onSelect,
          checked: o[m] || !1
        }))), E && r.a.createElement("td", null, r.a.createElement("button", {
          type: "button",
          className: "btn btn-link",
          "data-html": "true",
          "data-toggle": "tooltip",
          title: "Expand",
          onClick: function onClick() {
            return e.onExpand(m);
          }
        }, y ? r.a.createElement("i", {
          className: y
        }) : r.a.createElement("span", null, "⇕"))), c.map(function (e, t) {
          return r.a.createElement(k, {
            key: t,
            column: e
          });
        }), d.actionsColumn && r.a.createElement(P, null)), E && r.a.createElement("tr", {
          className: "collapse ".concat(a[m] ? "show" : "")
        }, r.a.createElement("td", {
          colSpan: f
        }, r.a.createElement(x, {
          row: n
        }))));
      };
    N.propTypes = q;
    var D = N,
      _ = function _(e) {
        var t = e.totalColumns,
          n = e.noDataText;
        return r.a.createElement("tbody", null, r.a.createElement("tr", null, r.a.createElement("td", {
          className: "text-center font-weight-normal",
          colSpan: t
        }, n)));
      };
    _.propTypes = {
      totalColumns: i.a.number.isRequired,
      noDataText: i.a.string.isRequired
    };
    var M = function M() {
      return r.a.createElement("p", null, "Please add your custom ExpandableRowComponent to component props");
    };
    M.propTypes = {
      row: i.a.object
    };
    n(4);
    function L(e) {
      return (L = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }
    function F(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function U(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
        var n = [],
          o = !0,
          r = !1,
          a = void 0;
        try {
          for (var i, c = e[Symbol.iterator](); !(o = (i = c.next()).done) && (n.push(i.value), !t || n.length !== t); o = !0);
        } catch (e) {
          r = !0, a = e;
        } finally {
          try {
            o || null == c.return || c.return();
          } finally {
            if (r) throw a;
          }
        }
        return n;
      }(e, t) || H(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function B(e) {
      if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
        if (Array.isArray(e) || (e = H(e))) {
          var t = 0,
            n = function n() {};
          return {
            s: n,
            n: function n() {
              return t >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[t++]
              };
            },
            e: function e(_e) {
              throw _e;
            },
            f: n
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o,
        r,
        a = !0,
        i = !1;
      return {
        s: function s() {
          o = e[Symbol.iterator]();
        },
        n: function n() {
          var e = o.next();
          return a = e.done, e;
        },
        e: function e(_e2) {
          i = !0, r = _e2;
        },
        f: function f() {
          try {
            a || null == o.return || o.return();
          } finally {
            if (i) throw r;
          }
        }
      };
    }
    function H(e, t) {
      if (e) {
        if ("string" == typeof e) return z(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? z(e, t) : void 0;
      }
    }
    function z(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
      return o;
    }
    function $(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }
    function J(e, t) {
      return !t || "object" !== L(t) && "function" != typeof t ? W(e) : t;
    }
    function W(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function G() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }
    function K(e) {
      return (K = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function V(e, t) {
      return (V = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    var Y = {
        keyField: i.a.string.isRequired,
        isLoading: i.a.bool,
        query: i.a.string.isRequired,
        requestFailed: i.a.bool,
        columns: i.a.arrayOf(i.a.object.isRequired).isRequired,
        items: i.a.array.isRequired,
        currentPage: i.a.number.isRequired,
        itemsPerPage: i.a.number,
        totalItems: i.a.number.isRequired,
        delay: i.a.number,
        tableClass: i.a.string,
        tableHeaderClass: i.a.string,
        options: i.a.objectOf(i.a.bool),
        translations: i.a.objectOf(i.a.string),
        icons: i.a.objectOf(i.a.string),
        loader: i.a.func,
        actionsComponent: i.a.func,
        headerActions: i.a.func,
        expandableRowComponent: i.a.func,
        onChangePage: i.a.func,
        onSearch: i.a.func,
        onSort: i.a.func,
        onInsert: i.a.func,
        onEdit: i.a.func,
        onDelete: i.a.func,
        onHeaderAction: i.a.func,
        onAction: i.a.func,
        onColumnClick: i.a.func,
        onMultipleDelete: i.a.func
      },
      Q = {
        isLoading: !1,
        requestFailed: !1,
        itemsPerPage: 10,
        delay: 300,
        tableClass: "",
        tableHeaderClass: "",
        options: {
          searchBox: !0,
          insertButton: !1,
          multipleSelect: !1,
          expandable: !1,
          actionsColumn: !1,
          pagination: !0
        },
        translations: {
          searchPlaceholder: "Search...",
          addButton: "Add",
          deleteButton: "Delete",
          sortTitle: "Sort",
          actionsColumnTitle: "Actions",
          editAction: "Edit",
          deleteAction: "Delete",
          noDataText: "No data found",
          requestFailedText: "API request failed",
          paginationFirst: "First",
          paginationLast: "Last"
        },
        icons: {
          addButtonIcon: "",
          deleteButtonIcon: "",
          tooltipIcon: "",
          sortIcon: "",
          expandIcon: "",
          editActionIcon: "",
          deleteActionIcon: ""
        },
        loader: function loader() {
          return r.a.createElement("p", null, "Loading data, please wait...");
        },
        expandableRowComponent: M,
        onChangePage: function onChangePage() {
          throw Error("Add onChangePage(page) method to component props");
        },
        onSearch: function onSearch() {
          throw Error("Add onSearch(search) method to component props");
        },
        onSort: function onSort() {
          throw Error("Add onSort(sortField, sortOrder) method to component props");
        },
        onInsert: function onInsert() {
          throw Error("Add onInsert() method to component props");
        },
        onEdit: function onEdit() {
          throw Error("Add onEdit(rowID) method to component props");
        },
        onDelete: function onDelete() {
          throw Error("Add onDelete(rowID, goToPage) method to component props");
        },
        onMultipleDelete: function onMultipleDelete() {
          throw Error("Add onMultipleDelete(values, goToPage) method to component props");
        },
        onHeaderAction: function onHeaderAction() {
          throw Error("Add onHeaderAction(type) method to component props");
        },
        onAction: function onAction() {
          throw Error("Add onAction(type, row) method to component props");
        },
        onColumnClick: function onColumnClick() {
          throw Error("Add onColumnClick() method to component props");
        }
      },
      X = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && V(e, t);
        }(c, e);
        var t,
          n,
          o,
          a,
          i = (t = c, function () {
            var e,
              n = K(t);
            if (G()) {
              var o = K(this).constructor;
              e = Reflect.construct(n, arguments, o);
            } else e = n.apply(this, arguments);
            return J(this, e);
          });
        function c(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (t = i.call(this, e)).state = {
            sortField: "",
            sortOrder: "",
            selectedCount: 0,
            selectAllItems: !1,
            selectedItems: {},
            expandRow: {}
          }, t.onExpand = t.onExpand.bind(W(t)), t.onMultipleSelect = t.onMultipleSelect.bind(W(t)), t.onSort = t.onSort.bind(W(t)), t.onDelete = t.onDelete.bind(W(t)), t.onSelect = t.onSelect.bind(W(t)), t.onMultipleDelete = t.onMultipleDelete.bind(W(t)), t;
        }
        return n = c, (o = [{
          key: "componentDidMount",
          value: function value() {
            var e,
              t = B(this.props.columns);
            try {
              for (t.s(); !(e = t.n()).done;) {
                var n = e.value;
                if (n.sort && n.sortOrder) {
                  this.setState({
                    sortField: n.dataField,
                    sortOrder: n.sortOrder
                  });
                  break;
                }
              }
            } catch (e) {
              t.e(e);
            } finally {
              t.f();
            }
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            this.props.options.multipleSelect && e.items !== this.props.items && this.setState({
              selectedCount: 0,
              selectAllItems: !1,
              selectedItems: {},
              expandRow: {}
            });
          }
        }, {
          key: "onSort",
          value: function value(e) {
            var t = this.state,
              n = t.sortField,
              o = t.sortOrder,
              r = "";
            r = n === e && "asc" === o ? "desc" : "asc", this.setState({
              sortField: e,
              sortOrder: r
            }), this.props.onSort(e, r);
          }
        }, {
          key: "onDelete",
          value: function value(e) {
            var t = this.props,
              n = t.currentPage,
              o = t.itemsPerPage,
              r = t.totalItems,
              a = A(n, o, r - 1);
            this.props.onDelete(e, a);
          }
        }, {
          key: "onMultipleDelete",
          value: function value() {
            for (var e = this.props, t = e.keyField, n = e.items, o = e.currentPage, r = e.itemsPerPage, a = e.totalItems, i = this.state.selectedItems, c = [], l = "string" == typeof n[0][t], s = 0, u = Object.entries(i); s < u.length; s++) {
              var p = U(u[s], 2),
                f = p[0];
              p[1] && c.push(l ? f : parseInt(f, 10));
            }
            var d = A(o, r, a - c.length);
            this.props.onMultipleDelete(c, d);
          }
        }, {
          key: "onExpand",
          value: function value(e) {
            if (this.props.options.expandable) {
              var t = this.state.expandRow,
                n = t[e] || !1;
              t[e] = !n, this.setState({
                expandRow: t
              });
            } else event.preventDefault();
          }
        }, {
          key: "onSelect",
          value: function value(e) {
            var t = e.target,
              n = "checkbox" === t.type ? t.checked : t.value,
              o = t.name,
              r = this.state,
              a = r.selectedCount,
              i = r.selectedItems,
              c = n ? a + 1 : a - 1;
            i[o] = n, this.setState({
              selectedCount: c,
              selectedItems: i
            });
          }
        }, {
          key: "onMultipleSelect",
          value: function value(e) {
            var t,
              n,
              o = e.target,
              r = "checkbox" === o.type ? o.checked : o.value,
              a = o.name,
              i = this.state.selectedItems,
              c = this.props,
              l = c.keyField,
              s = c.items,
              u = r ? s.length : 0,
              p = B(s);
            try {
              for (p.s(); !(n = p.n()).done;) i[n.value[l]] = r;
            } catch (e) {
              p.e(e);
            } finally {
              p.f();
            }
            this.setState((F(t = {}, a, r), F(t, "selectedCount", u), F(t, "selectedItems", i), t));
          }
        }, {
          key: "render",
          value: function value() {
            var e,
              t,
              n,
              o = this,
              a = this.state,
              i = a.selectAllItems,
              c = a.selectedCount,
              l = a.selectedItems,
              s = a.expandRow,
              u = this.props,
              p = u.keyField,
              f = u.isLoading,
              d = u.query,
              m = u.requestFailed,
              h = u.columns,
              b = u.items,
              y = u.currentPage,
              v = u.itemsPerPage,
              E = u.totalItems,
              x = u.tableClass,
              C = u.tableHeaderClass,
              S = u.options,
              w = u.translations,
              k = u.icons,
              P = u.delay,
              R = u.loader,
              I = u.headerActions,
              T = u.actionsComponent,
              A = u.expandableRowComponent,
              q = u.onSearch,
              N = u.onChangePage,
              M = u.onInsert,
              L = u.onEdit,
              F = u.onHeaderAction,
              U = u.onAction,
              B = u.onColumnClick,
              H = w.searchPlaceholder,
              z = w.addButton,
              $ = w.deleteButton,
              J = w.sortTitle,
              W = w.actionsColumnTitle,
              G = w.noDataText,
              K = w.requestFailedText,
              V = w.paginationFirst,
              Y = w.paginationLast,
              Q = k.addButtonIcon,
              X = k.deleteButtonIcon,
              Z = k.tooltipIcon,
              ee = k.sortIcon,
              te = R,
              ne = h.length + (S.multipleSelect ? 1 : 0) + (S.expandable ? 1 : 0) + (S.actionsColumn ? 1 : 0),
              oe = I,
              re = m || 0 === b.length,
              ae = !m && b.length > 0,
              ie = !f && !m && S.pagination,
              ce = (e = function e(_e3) {
                q(_e3);
              }, t = P, n = null, function () {
                for (var o = arguments.length, r = new Array(o), a = 0; a < o; a++) r[a] = arguments[a];
                var i = function i() {
                  return e.apply(void 0, r);
                };
                clearTimeout(n), n = setTimeout(i, t);
              });
            return r.a.createElement("div", {
              className: "animated fadeIn"
            }, r.a.createElement("div", {
              className: "row form-group"
            }, r.a.createElement("div", {
              className: "col-12 order-2 col-md-6 order-md-1 col-lg-4 col-xl-3 mb-1"
            }, S.searchBox && r.a.createElement(O, {
              placeholder: H,
              query: d,
              onChange: ce
            })), r.a.createElement("div", {
              className: "col-12 order-1 col-md-6 order-md-2 col-lg-8 col-xl-9 mb-1"
            }, r.a.createElement("span", {
              className: "async-table-header-actions float-right"
            }, S.insertButton && r.a.createElement("button", {
              type: "button",
              className: "btn btn-primary",
              onClick: M,
              disabled: m || f
            }, Q && r.a.createElement("i", {
              className: Q
            }), " ", z), oe && r.a.createElement(oe, {
              onHeaderAction: F
            }), S.multipleSelect && r.a.createElement("button", {
              type: "button",
              className: "btn btn-danger",
              onClick: this.onMultipleDelete,
              disabled: 0 === c
            }, X && r.a.createElement("i", {
              className: X
            }), " ", $, " ", r.a.createElement("span", {
              style: {
                paddingTop: "8px"
              },
              className: "badge badge-pill badge-light"
            }, c))))), r.a.createElement("div", {
              className: "row"
            }, r.a.createElement("div", {
              className: "col-md-12"
            }, f ? r.a.createElement("div", {
              className: "animated fadeIn"
            }, r.a.createElement(te, null)) : r.a.createElement("div", {
              className: "table-responsive"
            }, r.a.createElement("table", {
              className: "table async-table-style ".concat(x)
            }, r.a.createElement(j, {
              tableHeaderClass: C,
              selectAllItems: i,
              columns: h,
              options: S,
              tooltipIcon: Z,
              sortTitle: J,
              sortIcon: ee,
              actionsColumnTitle: W,
              onMultipleSelect: this.onMultipleSelect,
              onSort: this.onSort
            }), re && r.a.createElement(_, {
              totalColumns: ne,
              noDataText: m ? K : G
            }), ae && b.map(function (e) {
              return r.a.createElement(D, {
                key: e[p],
                keyField: p,
                item: e,
                selectedItems: l,
                actionsComponent: T,
                expandRow: s,
                columns: h,
                totalColumns: ne,
                options: S,
                translations: w,
                icons: k,
                expandableRowComponent: A,
                onSelect: o.onSelect,
                onExpand: o.onExpand,
                onEdit: L,
                onDelete: o.onDelete,
                onAction: U,
                onColumnClick: B
              });
            }))))), ie && r.a.createElement("div", {
              className: "row form-group"
            }, r.a.createElement("div", {
              className: "col-md-12"
            }, r.a.createElement("span", {
              className: "float-right"
            }, r.a.createElement(g, {
              currentPage: y,
              pageSize: v,
              items: E,
              onChangePage: N,
              firstLink: V,
              lastLink: Y
            })))));
          }
        }]) && $(n.prototype, o), a && $(n, a), c;
      }(o.Component);
    X.propTypes = Y, X.defaultProps = Q;
    var Z = X;
    t.default = Z;
  }]);
});